import React, { useState } from "react";
import Classes from "./styles/style.module.css";
import { AiFillPlayCircle, AiOutlineClose } from "react-icons/ai";
import Modal from "react-modal";
import ReactPlayer from "react-player";
import { useLocation } from "react-router";

const VideoBanner = ({ bannerData, smallVideo }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { pathname } = useLocation();
  return (
    <div
      className={`${Classes.bannerContainer} ${smallVideo && Classes.smallBanner
        }`}

      style={{ border: pathname == '/hubble' ? '2px solid var(--hubblePurple)' : "none" ,borderRadius:'18px' }}
    >
      <img src={bannerData.videoCover} alt="videoBanner" />
      <div
        className={Classes.playLogoContainer}
        onClick={() => setIsOpen(true)}
      >
        <AiFillPlayCircle fontSize={45} onClick={() => setIsOpen(true)} />
      </div>
      <Modal
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
        contentLabel="Video Modal"
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.75)",
            zIndex: "99999",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          },
          content: {
            backgroundColor: "transparent",
            border: "none",
            position: "relative",
            inset: "unset",
            padding: "30px",
          },
        }}
      >
        <AiOutlineClose
          size={25}
          className={Classes.closeIcon}
          onClick={() => setIsOpen(false)}
        />
        <ReactPlayer
          url={bannerData.src}
          playing={isOpen}
          controls={true}
          width="100%"
          height="100%"
        />
      </Modal>
    </div>
  );
};

export default VideoBanner;
